import { render, staticRenderFns } from "./AlterarProfissional.vue?vue&type=template&id=868f36de&"
import script from "./AlterarProfissional.vue?vue&type=script&lang=js&"
export * from "./AlterarProfissional.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports